import React from "react";
import BaseEdge, { roundedOrthPath, roundTo } from "./BaseEdge";

function choosePorts(fromNode, toNode) {
  return {
    fromPort: "right",
    toPort: "left",
  };
}

function anchorPoint(node, port) {
  const w = node.width;
  const h = node.height;

  switch (port) {
    case "left":
      return { x: roundTo(node.x), y: roundTo(node.y + h / 2) };
    case "right":
      return { x: roundTo(node.x + w), y: roundTo(node.y + h / 2) };
    case "top":
      return { x: roundTo(node.x + w / 2), y: roundTo(node.y) };
    case "bottom":
      return { x: roundTo(node.x + w / 2), y: roundTo(node.y + h) };
    default:
      return { x: roundTo(node.x + w / 2), y: roundTo(node.y + h / 2) };
  }
}

export default function OrthogonalEdge({
  edge,
  nodeById,
  edgeIndex,
  selectedIndex,
  onSelectEdge,
  onStartEdgeDrag,
  edgeControls,
  color,
  isCriticalEdge = false,
  isInChain = false,
  isHovered,
  isSelected,
  onHoverEnter,
  onHoverLeave,
  opacity = 1.0,
  strokeDasharray,
  strokeWidth,
}) {
  const fromNode = nodeById[edge.from];
  const toNode = nodeById[edge.to];
  if (!fromNode || !toNode) return null;

  const ports = choosePorts(fromNode, toNode);
  const src = anchorPoint(fromNode, ports.fromPort);
  const dst = anchorPoint(toNode, ports.toPort);

  const ctrl = edgeControls?.[edgeIndex];

  const defaultMidX = Math.round((src.x + dst.x) / 2);

  const cp1 = ctrl?.cp1 ?? { x: defaultMidX, y: src.y };
  const cp2 = ctrl?.cp2 ?? { x: defaultMidX, y: dst.y };

  const pts = [src, cp1, cp2, dst];
  const d = roundedOrthPath(pts);

  const labelPos = {
    x: Math.round((cp1.x + cp2.x) / 2),
    y: Math.round((src.y + dst.y) / 2) - 12,
  };

  // Determine if this edge is selected
  const isEdgeSelected = selectedIndex === edgeIndex;

  // Determine final color
  const finalColor = isInChain ? "#1A73E8" : color;

  return (
    <BaseEdge
      d={d}
      stroke={finalColor}
      strokeWidth={strokeWidth}
      strokeDasharray={strokeDasharray}
      isHovered={isHovered}
      isSelected={isEdgeSelected}
      isInChain={isInChain}
      isCriticalEdge={isCriticalEdge}
      onHoverEnter={onHoverEnter}
      onHoverLeave={onHoverLeave}
      onSelect={() => onSelectEdge && onSelectEdge(edgeIndex)}
      onStartDrag={(e) =>
        onStartEdgeDrag &&
        onStartEdgeDrag(edgeIndex, {
          clientX: e.clientX,
          clientY: e.clientY,
        })
      }
      label={edge.label}
      labelPos={labelPos}
      opacity={opacity}
    />
  );
}
